import { setSdkConfig } from './config/setSdkConfig';
import { LogiSDKConfig } from '../shares/model/config';
import { SwipeGames } from './launch/swipeGames';
import { MiniGames } from './launch/miniGames';
import { Simulate } from './launch/simulate';
import { SimulateSpecials } from './launch/simulateSpecials';
import logger from '../shares/lib/logger';

export const LogiSdk = {
  init: async (config: LogiSDKConfig): Promise<void> => {
    const sdkConfig = setSdkConfig(config);

    logger.info('LogiSDK initialized', sdkConfig);
  },

  swipeGames: SwipeGames,
  miniGames: MiniGames,
  simulate: Simulate,
  simulateSpecials: SimulateSpecials,
};

export default LogiSdk;
